module.exports = __webpack_public_path__ + "img/gsb16.16c40ab2.png";